<ng-container *ngIf="hasPassword$ | async; else hasPassword">
  <app-change-password (onSubmit)="changePassword($event)"></app-change-password>
</ng-container>

<ng-template #hasPassword>
  <app-set-password (onSubmit)="setPassword($event)"></app-set-password>
</ng-template>
